export default {
    "de": {
        "messages": {
            "signature_agree": "Mit der Unterzeichnung dieses Rapportes anerkennt der Auftraggeber oder deren Vertretung die aufgeführten Positionen und bestätigt deren Richtigkeit. Der Kunde hat je nach Service die enthaltene Präsentation (z.B. Virtual PBX Training) bzw. alle notwendigen Informationen vom Techniker erhalten. Ebenfalls wurde der Kunde darauf hingewiesen das nach der Installation für weitere Fragen oder technische Probleme der Kundenservice bzw. Technische Support wie oben aufgeführt telefonisch wie auch per E-Mail erreichbar ist. Eine Digitale Kopie dieses Arbeitsrapportes wird dem Kunden in Form eines PDF per Email an {customerEmailAddress} zugestellt. Es gelten die Allgemeinen Geschäftsbedingungen von VTX: https://www.vtx.ch/de/agb",
            "info_after_install": {
                "title": "Technischer und Administrativer Support nach der Installation",
                "text_tech": "Für sämtliche Fragen nach der Installation zu technischen Problemen kontaktieren Sie bitte direkt unseren Technischen Support wie folgt:\r\n    <br />  - per Email : support@vtx.ch\r\n    <br /> - per Telefon: 0840 111 240 (Lokaltarif) Montag - Freitag, 08.00 – 12.00 Uhr und 13.00 – 17.00 Uhr ",
                "text_admin": "Für Administrative Anliegen wie Fragen zur Rechnung etc... kontaktieren Sie bitte direkt unseren Kundenservice unter:\r\n    <br />  - per Email : info@vtx.ch\r\n    <br /> - per Telefon: 0800 200 200 (Gratis) Montag - Freitag, 08.00 – 12.00 Uhr und 13.00 – 17.00 Uhr "
            },
            "statment": "Erklärung"
        },
        "ap_form": {
            "company_name": "Firmen Name",
            "customer_number": "Kundennummer",
            "service_number": "Service Nummer",
            "ticket_number": "Ticket Nummer",
            "place_and_date": "Ort und Datum",
            "customer_name": "Kunden Name",
            "installer_name": "Name Installateur",
            "customer_signature": "Unterschrift Kunde",
            "installer_signature": "Unterschrift Installateur",
            "comment": "Kommentar",
            "question": "Anruf",
            "answer": "Ergebnis",
            "place": "Ort",
            "customer_email": "Kunden Email",
            "customer": "Kunde",
            "templateName": "Template Name",
            "date": "Datum",
            "time_spent": "Verbrauchte Zeit"
        },
        "email": {
            "dear": "Sehr geehrte Kundin, Sehr geehrter Kunde",
            "thanks_for_choosing": "Vielen Dank, dass Sie sich für VTX entschieden haben.",
            "recently": "Vor kurzem haben Sie einen neuen Dienst von VTX erhalten. Bitte laden Sie eine digitale Kopie vom \"Arbeitsrapport\" herunter, den Sie unter folgender Adresse finden:",
            "recently_closure_only": "Vor kurzem hatten Sie Kontakt mit der Firma VTX.",
            "in_order_to_access": "Um auf den \"Arbeitsrapport\" zuzugreifen, kopieren Sie bitte das unten stehende Passwort.",
            "click_to_go_to": "Klicken Sie hier, um zum Download vom Arbeitsrapport zu gelangen",
            "click_to_go_to_closure_only": "Klicken Sie hier, um zur Bewertung zu gelangen",
            "thank_you": "Mit freundlichen Grüssen",
            "your_vtx_team": "Ihr VTX-Team",
            "links_stays_active": "Dieser Link bleibt bis am {validUntil} aktiv. Danach wird der Link deaktiviert und Sie müssen einen neuen Link anfordern, wenn Sie erneut darauf zugreifen möchten.",
            "remainder_download_report_text": "Wir durften am {date} ein Produkt von VTX bei Ihnen in Betrieb nehmen. Uns ist aufgefallen das Sie bis jetzt den Arbeitsrapport noch nicht heruntergeladen haben.",
            "remainder_download_possible_to_rate": "Auf der Download Seite haben sie ebenfalls die Möglichkeit eine kleine Bewertung abzugeben und uns so eine Rückmeldung über unseren Service zu geben."
        },
        "closure": {
            "authentication_required": "Authentifizierung erforderlich",
            "before_proceeding": "Um den Arbeitsrapport als PDF herunterzuladen müssen sie sich anmelden",
            "enter_secret": "Bitte geben Sie das Passwort ein welches Sie in unserer Email erhalten haben.",
            "product_type": "Produktart",
            "accept_protocol": "Arbeitsrapport",
            "signed_on": "unterzeichnet",
            "dear_customer": "Sehr geehrte Kundin, Sehr geehrter Kunde, kürzlich haben Sie einen neuen Dienst von VTX erhalten. Bitte laden Sie eine digitale Kopie vom Arbeitsrapport herunter. Klicken Sie hierfür auf \"Download PDF\"",
            "how_we_did_it_title": "Ihr Feedback interessiert uns",
            "how_we_did_it_text": "Um unseren Service stetig zu Verbesseren sind wir auf ihre Rückmeldung angwiesen. Wir würden uns freuen wenn sie sich kurz einen Moment Zeit nehmen und uns bewerten.",
            "tnx_4_fdbkc": "Danke für ihr Feedback",
            "send_fdbkc": "Feedback Schicken"
        }
    },
    "en": {
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "messages": {
            "signature_agree": "English text here, AGB",
            "info_after_install": {
                "title": "English: AUSKÜNFTE UND TECHNISCHER SUPPORT NACH DER INSTALLATION",
                "text": "ENglish: Votre installation Virtual PBX étant terminée, pour toute demande technique, veuillez contacter notre support:\r\n    <br /> - par mail : support@vtx-telecom.ch ou\r\n    <br /> - par téléphone : 0840 111 240 (en tarif local) - lundi au vendredi de 8 h à 18 h"
            },
            "statment": "Statment"
        },
        "ap_form": {
            "company_name": "Company Name",
            "customer_number": "Customer Number",
            "service_number": "Service Number",
            "ticket_number": "Ticket Number",
            "place_and_date": "Place and Date",
            "customer_name": "Customer Name",
            "installer_name": "installer Name",
            "customer_signature": "Customer Signature",
            "installer_signature": "Installer Signature",
            "comment": "Comment",
            "question": "Question",
            "answer": "Response",
            "place": "Place",
            "customer_email": "Customer Email",
            "customer": "Customer",
            "templateName": "Template Name",
            "date": "Date",
            "time_spent": "Time Spent"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "email": {
            "dear": "Dear Customer",
            "thanks_for_choosing": "Thank you for choosing VTX.",
            "recently": "Recently you got a new service from VTX, please consider downloading digital copy of \"Accept Protocol\" which can be found on this address:",
            "recently_closure_only": "Recently you had contact with the company VTX.",
            "in_order_to_access": "In order to access the \"Accept Protocol\" please copy the password below.",
            "click_to_go_to": "Click here to go to Accept Protocol",
            "click_to_go_to_closure_only": "Click here to go to the rating",
            "thank_you": "Thank you",
            "your_vtx_team": "your VTX team",
            "links_stays_active": "This link will stay active until {validUntil}. After that the link will be disabled and you will need to request new link if you need to access it again.",
            "remainder_download_report_text": "We were allowed to put a VTX product into operation at your site on the {date}. We noticed that you have not yet downloaded the report.The following link gives you from now on another 10 days time to get it for your documents. After that it will not be possible anymore.",
            "remainder_download_possible_to_rate": "On the download page you also have the possibility to give us a small evaluation and give us a feedback about our service."
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "closure": {
            "authentication_required": "Authentication required",
            "before_proceeding": "Before proceeding to the Work Report, we want to make sure you are allowed to access this page",
            "enter_secret": "Please enter the Secret that you have received by the Email from the VTX Work-Report",
            "product_type": "Product Type",
            "accept_protocol": "Accept Protocol",
            "signed_on": "signed on",
            "dear_customer": "Recently you got a new service from VTX, please consider downloading digital copy of \"Accept Protocol\" which can be found by clicking on \"Download PDF\" button",
            "how_we_did_it_title": "How we did it",
            "how_we_did_it_text": "We would very much appreciate it if you would please take a few minutes to share your experience with us. Your valuable feedback will help us build a better customer experience. Thank you!",
            "tnx_4_fdbkc": "Thank you for your feedback",
            "send_fdbkc": "Send Feedback"
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        }
    },
    "fr": {
        "messages": {
            "signature_agree": "En signant ce rapport, le client ou son représentant accepte les éléments listés et confirme leur exactitude. Selon le service, le client a reçu la présentation incluse (par exemple, Virtual PBX Training) ou toutes les informations nécessaires du technicien. Le client a également été informé qu'après l'installation pour d'autres questions ou problèmes techniques, le service client ou le support technique peut être contacté par téléphone ou par e-mail comme indiqué ci-dessus. Une copie numérique de ce rapport sera envoyée au client sous forme de fichier PDF par email à {customerEmailAddress}. Les conditions générales de VTX s'appliquent: https://www.vtx.ch/fr/cgv",
            "info_after_install": {
                "title": "Assistance technique et administrative après installation ",
                "text_tech": "Pour toutes questions technique après l’installation. Nous vous prions de prendre directement contact avec notre support technique :\r\n    <br />  - par Email : support@vtx.ch\r\n    <br /> - par téléphone: 0840 111 240 (tarif local depuis reseau fixe) du lundi au Vendredi, 08h00 à 12h00 et de 13h00 à 17h00.",
                "text_admin": "Pour les questions commerciales ainsi que la facturation, veuillez contacter notre service administratif:\r\n    <br />  - par Email : info@vtx.ch\r\n    <br /> - par téléphone: 0800 200 200 (gratuit depuis le réseau fixe) du lundi au Vendredi, 08h00 à 12h00 et de 13h00 à 17h00."
            },
            "statment": "Explications"
        },
        "ap_form": {
            "company_name": "Nom de la société",
            "customer_number": "Numéro de client",
            "service_number": "Numéro de préstation",
            "ticket_number": "Numéro de ticket",
            "place_and_date": "Lieu et date",
            "customer_name": "Nom du client",
            "installer_name": "Nom de l'installateur",
            "customer_signature": "Signature du client",
            "installer_signature": "Signature installateur",
            "comment": "Commentaires",
            "question": "Question",
            "answer": "Réponse",
            "place": "Localité",
            "customer_email": "Email client",
            "customer": "Client",
            "templateName": "Nom du Modèle",
            "date": "Date",
            "time_spent": "Temps passé"
        },
        "email": {
            "dear": "Cher client",
            "thanks_for_choosing": "Merci d'avoir choisi VTX.",
            "recently": "VTX vous a récemment installé un nouveau service. Vous pouvez télécharger une copie numérique du rapport d’intervention. Ce dernier se trouve à l’adresse suivante:",
            "recently_closure_only": "Dernièrement, vous avez des contacts avec la société VTX.",
            "in_order_to_access": "Pour accéder au rapport d'installation, veuillez copier le mot de passe ci-dessous.",
            "click_to_go_to": "Cliquez ici pour accéder au rapport d’intervention",
            "click_to_go_to_closure_only": "Cliquez ici pour accéder à l’évaluation",
            "thank_you": "Merci",
            "your_vtx_team": "Votre équipe VTX",
            "links_stays_active": "Ce lien restera actif jusqu'au {validUntil}. Suite à cela, le lien sera désactivé et vous devrez en demander un nouveau.",
            "remainder_download_report_text": "Nous avons été autorisés à mettre en service un produit VTX sur votre site le {date}. Nous avons remarqué que vous n'avez pas encore téléchargé le rapport.",
            "remainder_download_possible_to_rate": "Sur la page de téléchargement, vous avez également la possibilité de nous donner une petite évaluation et de nous faire part de vos commentaires sur notre service."
        },
        "closure": {
            "authentication_required": "Identification requise",
            "before_proceeding": "Avant de passer au rapport de travail, nous devrons vérifier que vous êtes autorisé à accéder à cette page",
            "enter_secret": "Veuillez entrer le code que vous avez reçu par courrier électronique.",
            "product_type": "Type de Produit",
            "accept_protocol": "Accepter le rapport",
            "signed_on": "signé le",
            "dear_customer": "Vous disposez depuis peu d’un nouveau service VTX. Vous pouvez télécharger la copie numérique du rapport d’intervention en cliquant sur \"Download PDF\".",
            "how_we_did_it_title": "Votre satisfaction est importante pour nous.",
            "how_we_did_it_text": "Nous vous serions reconnaissants de bien vouloir prendre quelques instants pour partager votre expérience avec nous. Vos précieux commentaires nous aident à créer une meilleure expérience client. Merci !",
            "tnx_4_fdbkc": "Merci pour votre avis",
            "send_fdbkc": "Envoyer votre avis"
        }
    }
}
